import type { RefObject } from "react";

export interface ShopHeroGlowProps {
  /** Nodo donde `useHeroPointerGlow` escribe `--hero-x` y `--hero-y`. */
  glowRef: RefObject<HTMLDivElement | null>;
}

/**
 * El resplandor violeta que sigue al ratón.
 *
 * ── El color no es una elección libre ────────────────────────────────
 * `rgba(92, 79, 214, …)` es `ds-violet-pop` en crudo. Va literal y no como
 * `bg-ds-violet-pop/22` porque el valor tiene que vivir DENTRO de un
 * `radial-gradient` junto a las variables de posición, y la utility de
 * color de Tailwind no entra ahí. Si el token cambia, este número cambia
 * con él.
 *
 * ── Por qué 22 % y ni un punto más ───────────────────────────────────
 * Esta capa ACLARA el fondo justo donde está el cursor, que es donde la
 * persona está mirando. El 22 % es el valor con el que se midió el peor
 * caso de contraste del titular; subirlo invalida la medición y puede
 * dejar el texto por debajo del mínimo en el fotograma más claro del
 * vídeo.
 *
 * ── Sin ratón se queda quieto en un sitio sensato ────────────────────
 * Los valores por defecto de las variables (`50% 35%`) dejan el
 * resplandor detrás de la forma del vídeo. Es lo que se ve en un teléfono,
 * donde el efecto no se activa, y en el primer fotograma antes de que el
 * cursor se mueva por primera vez.
 */
export function ShopHeroGlow({ glowRef }: ShopHeroGlowProps) {
  return (
    <div
      ref={glowRef}
      className="absolute inset-0 bg-[radial-gradient(26rem_26rem_at_var(--hero-x,50%)_var(--hero-y,35%),rgba(92,79,214,0.22),transparent_70%)]"
    />
  );
}
